// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__xQAqu","unreadBadge":"styles_unreadBadge__11Hl9","modalContent":"styles_modalContent__1yJss","modal":"styles_modal__1bp58"};